<template>
  <div id="map" ref="map" class="map"></div>
</template>

<script>
import 'ol/ol.css';
import { Map, View, Overlay } from 'ol';
import { fromLonLat } from 'ol/proj.js';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';

export default {
  name: 'OpenApiMap',
  props: {
    latitude: {
      type: Number,
      required: true,
    },
    longitude: {
      type: Number,
      required: true,
    },
  },
  mounted: function() {
    const center = fromLonLat([this.longitude, this.latitude]);

    const markerEl = document.createElement('div');
    markerEl.classList.add('map-marker');
    markerEl.innerHTML = '<i class="fas fa-map-marker-alt fa-2x"></i>';

    const map = new Map({
      target: 'map',
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center,
        zoom: 15,
      }),
    });

    const marker = new Overlay({
      position: center,
      positioning: 'center-center',
      element: markerEl,
      stopEvent: false,
    });
    map.addOverlay(marker);

    this.$mapObject = map;
  },
};
</script>
